import React from "react";
import { Users } from "lucide-react";
import { PowerballBall } from "./PowerballBall";

export function CouncilPanel({ pick }) {
  const agreed = new Set(pick.agreement?.whites || []);
  return (
    <div data-testid="council-panel" className="mt-8 max-w-3xl mx-auto">
      <div className="label-caps flex items-center justify-center gap-2 text-parchment/50">
        <Users className="w-3 h-3" strokeWidth={1.5} /> The council deliberated ·
        <span data-testid="council-agreement" className="text-oracle">
          {agreed.size} white{agreed.size === 1 ? "" : "s"}{pick.agreement?.powerball ? " + Powerball" : ""} agreed
        </span>
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3 text-left">
        {pick.council.map((m) => (
          <div key={m.model} data-testid={`council-member-${m.model.split(/[\s.]/)[0].toLowerCase()}`} className="bg-black/30 border border-white/5 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div className="label-caps text-oracle">{m.model}</div>
              <div className="font-body text-xs text-parchment/50">{(m.confidence * 100).toFixed(0)}%</div>
            </div>
            <div className="mt-3 flex items-center gap-1.5 flex-wrap">
              {m.whites.map((n) => (
                <span key={n} className={agreed.has(n) ? "rounded-full ring-2 ring-oracle ring-offset-2 ring-offset-ink" : "opacity-70"}>
                  <PowerballBall n={n} size="sm" />
                </span>
              ))}
              <span className="text-parchment/30 mx-0.5">·</span>
              <span className={pick.agreement?.powerball ? "rounded-full ring-2 ring-oracle ring-offset-2 ring-offset-ink" : "opacity-70"}>
                <PowerballBall n={m.powerball} red size="sm" />
              </span>
            </div>
            <p className="mt-3 font-heading italic text-sm text-parchment/70 leading-snug line-clamp-3">&ldquo;{m.reasoning}&rdquo;</p>
          </div>
        ))}
      </div>
    </div>
  );
}
